import React from 'react';
import RouteManager from '../../routes/RouteManager';

const Body = () => <RouteManager />;

export default Body;
